import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { mapCustomerAddressInformation } from "../utils/customerAddressInformation"

export const queryCustomerShippingAddresses = {
  async customerShippingAddresses(parent, args, context, info) {
    const { customerId, customerKey, customerNumber } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ADDRESSES,
      operation: Operations.READ,
    })

    const customer = await getCustomer({ id: customerId, key: customerKey, number: customerNumber })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    if (customer?.addresses?.lenght <= 0) return null

    const customerAddresses = customer.addresses || []
    const shippingAddressIds = customer?.shippingAddressIds || []

    // filtered shipping addresses
    const shippingAddresses = customerAddresses.filter((address) => shippingAddressIds.includes(address.id))

    if (shippingAddresses?.length <= 0) return null

    // mapp the shipping addresses information with required and available fields
    const mappedShippingAddresses = shippingAddresses?.map((address) => {
      return mapCustomerAddressInformation(address, customer)
    })

    return { items: mappedShippingAddresses, total: mappedShippingAddresses?.length || 0 }
  },
}
